export const isCustomerTemplateKey = (key: string) => key.indexOf('customer-template.') > -1;
